<template>
  <div
    class="base-label"
    :class="{ 'label--top': labelPosition === 'top', 'label--block': block }"
  >
    <div
      class="base-label__wrap"
      :style="labelStyle"
      ref="label"
    >
      <slot name="label">
        <label class="base-label__label">{{ label }}</label>
      </slot>
    </div>
    <div
      :class="['base-label__content', { 'is-overflow': showOverflow }]"
      :style="contentStyle"
      ref="content"
      :title="content"
    >
      <span
        v-if="contentBox"
        class="label__content"
      >
        <slot>{{ content }}</slot>
      </span>
      <span v-else>
        <slot>{{ content }}</slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLabel',

  props: {
    label: String,
    content: [String, Number],
    labelWidth: {
      type: [ String, Number ],
      default: 'auto'
    },
    lineHeight: [ String, Number ],
    labelPosition: {
      type: String,
      default: 'left'
    },
    contentBox: Boolean,
    block: Boolean,
    showOverflow: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    contentStyle () {
      return {
        marginLeft: this.labelPosition === 'top' ? undefined : this.labelStyle.width,
        lineHeight: this.lineHeight
      }
    },
    labelStyle () {
      const style = {
        width: this.labelWidth === 'auto' ? this.computedLabelWidth : this.labelWidth,
        lineHeight: this.lineHeight
      }
      return style
    }
  },

  mounted () {
    this.updateLabelStyle()
  },

  updated () {
    this.updateLabelStyle()
  },

  data () {
    return {
      computedLabelWidth: ''
    }
  },

  methods: {
    updateLabelStyle () {
      const { label } = this.$refs
      if (label) {
        let { width } = label.getBoundingClientRect()
        width = Math.ceil(parseFloat(width))
        if (width > 0) {
          this.computedLabelWidth = width + 'px'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .base-label {
    display: inline-block;
    max-width: 100%;
    @include clearfix;
    @include ellipsis(auto, true);
    $root: &;
    &__wrap {
      float: left;
      text-align: right;
      line-height: 28px;
      #{$root}.label--top > & {
        float: none;
        padding: 0 0 10px 0;
        text-align: left;
      }
    }
    &.label--block {
      display: block;
    }
    &__label {
      padding-right: 1em;
    }
    &__content {
      line-height: 28px;
      color: $--color-text-primary;
      max-width: 100%;
      white-space: initial;
      &.is-overflow {
        @include ellipsis(auto, true);
        .label__content {
          @include ellipsis;
        }
      }
    }

    .label__content {
      display: inline-block;
      padding: 0 10px;
      color: $--color-text-primary;
      min-width: 108px;
      min-height: 28px;
      line-height: 28px;
      background-color: #f5f7fa;
      border: 1px solid #e4e7ed;
      border-radius: 4px;
      vertical-align: middle;
    }
  }
</style>
